<p-progress-spinner *ngIf="loading"/>
<ng-container *ngIf="contentType && !loading">
  <!-- For HTML content -->
  <ng-container *ngIf="webContent && webContent.type == 'html' ">
    <div id="html-{{webContent.id}}" [innerHTML]="webContent.value"></div>
  </ng-container>

  <!-- For plaintext content -->
  <ng-container *ngIf="webContent && webContent.type == 'text'">
    {{webContent.value}}
  </ng-container>


  <!-- For image content -->
  <ng-container *ngIf="webContent && webContent.type == 'image'">
    <img id="image-content" [src]="webContent.value" alt="Image webContent.value">
  </ng-container>
  <ng-content></ng-content>
</ng-container>